/**
 * AvatarGroup — overlapping avatars. Wrap Avatar components.
 */

import React, { createContext, useContext } from "react";
import { getAvatarGroupClasses } from "./Avatar.styles";
import type { AvatarGroupProps } from "./Avatar.types";
import type { AvatarSize } from "./Avatar.types";

const AvatarGroupSizeContext = createContext<AvatarSize>("md");

export const AvatarGroup: React.FC<AvatarGroupProps & { size?: AvatarSize }> = ({
  children,
  className,
  size = "md",
}) => (
  <AvatarGroupSizeContext.Provider value={size}>
    <div className={getAvatarGroupClasses(className)}>{children}</div>
  </AvatarGroupSizeContext.Provider>
);

export function useAvatarGroupSize(): AvatarSize {
  return useContext(AvatarGroupSizeContext);
}
